import { useState, useRef } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import JoditEditor from 'jodit-react';

function BlogEditor({ posts, setPosts }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditing = !!id;
  const post = isEditing ? posts.find(p => p.id === parseInt(id)) : null;
  const [title, setTitle] = useState(post ? post.title : '');
  const [content, setContent] = useState(post ? post.content : '');
  const editor = useRef(null);

  const config = {
    readonly: false,
    height: 400,
    //buttons: ['bold', 'italic', 'underline', 'link', 'image', 'source'],
    uploader: { insertImageAsBase64URI: true },
    placeholder: 'Start typing your blog post...',
  };

  const handleSubmit = e => {
    e.preventDefault();
    const currentDate = new Date().toISOString().split('T')[0];
    let updatedPosts;

    if (isEditing) {
      updatedPosts = posts.map(p =>
        p.id === parseInt(id) ? { ...p, title, content, date: currentDate } : p,
      );
    } else {
      updatedPosts = [...posts, { id: posts.length + 1, title, content, date: currentDate }];
    }

    setPosts(updatedPosts);
    localStorage.setItem('posts', JSON.stringify(updatedPosts));
    navigate('/');
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">{isEditing ? 'Edit Post' : 'Create Post'}</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-lg font-medium mb-1">Title</label>
          <input
            type="text"
            value={title}
            onChange={e => setTitle(e.target.value)}
            className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
            required
          />
        </div>
        <div>
          <label className="block text-lg font-medium mb-1">Content</label>
          <JoditEditor
            ref={editor}
            value={content}
            config={config}
            onBlur={newContent => setContent(newContent)}
          />
        </div>
        <div className="flex space-x-4">
          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
          >
            {isEditing ? 'Update Post' : 'Create Post'}
          </button>
          <Link to="/" className="text-blue-600 hover:underline px-4 py-2">
            Cancel
          </Link>
        </div>
      </form>
    </div>
  );
}

export default BlogEditor;